/*
 * XOVIST shipping row + delivery estimate + UK/EU 2-pack line by detected country (v5, 2026-10-11)
 * ------------------------------------------------------------------
 * Why:     on the Basic plan Shopify does not pick the visitor's country, so localization.country
 *          stays the store default (US) unless the shopper picks one. A UK visitor then sees
 *          "Shipping: Free" in the cart and the US delivery band on the product page.
 * Country: the one lookup assets/xv-card-gate.js already makes (xvCardGate.onSettle / .country(),
 *          else its sessionStorage cache 'xv_card_geo'). This file makes no request of its own.
 * Only while the store country is still the default (data-default-country, US): a country the
 * shopper picked is their ship-to, and Liquid already rendered it right, so it is left alone.
 * 1. Cart summary (snippets/xv-cart-summary.liquid, drawer and /cart): if the detected country is
 *    not a free-shipping country, the "Free" Shipping row reads "At checkout" and loses its
 *    xv-sum__free styling. Totals and the cart are never touched; it never switches to "Free".
 * 2. Delivery estimate (snippets/xv-delivery-timeline.liquid): if the detected country's band differs
 *    from the box's data-lo/data-hi, both are set and Ships/Arrives are recomputed with the
 *    snippet's own algorithm (copied below unchanged). A box whose Liquid band is not the store
 *    country's band in the lists below is left alone: the snippet changed and these lists are stale.
 * 3. 2-pack line (snippets/xv-2pack-nudge.liquid, product page, 2026-10-11): Liquid prints it with `hidden`
 *    unless the picked country is on its own data-countries list (GB + EU27). If the detected country is on
 *    that list, `hidden` is removed. Copy only: it never selects a quantity option or touches the cart, and
 *    it is never hidden again by this file.
 * Bands (2026-10-11, audit item 13 / C4): JP moved to 8-16 (band B) and PK to 10-21 (band C).
 * Re-applied at once after cart-drawer:render/update/open, pageshow, load and any re-render that
 * adds elements (MutationObserver, only while there is something to correct). Idempotent.
 * Fails safe: no detected country, or a lookup that failed, changes nothing.
 */
(function () {
  'use strict';
  if (window.xvShipGeo) return;

  var me = document.currentScript || document.getElementById('xv-ship-geo-js');
  function attr(n) { return (me && me.getAttribute(n)) || ''; }
  var STORE = attr('data-store-country').toUpperCase();
  var DEFAULT = (attr('data-default-country') || 'US').toUpperCase();
  /* keep in sync with xv_free_ship_countries in snippets/xv-cart-summary.liquid */
  var FREE = ['US', 'CA', 'AU', 'NZ', 'JP', 'KR', 'SG', 'HK', 'MY', 'CH'];
  /* keep in sync with xv_band_b / xv_band_c in snippets/xv-delivery-timeline.liquid (default 7-12) */
  var BAND_B = ['JP', 'CH', 'NO', 'AE', 'LU', 'AT', 'ES', 'CZ', 'SK', 'HU', 'SI', 'EE', 'LV', 'LT'];
  var BAND_C = ['PK', 'FI', 'MT', 'TW'];
  var MARK = 'data-xv-ship-geo';

  var geo = '';
  var active = false;

  function band(c) {
    if (BAND_B.indexOf(c) > -1) return [8, 16];
    if (BAND_C.indexOf(c) > -1) return [10, 21];
    return [7, 12];
  }
  function each(sel, fn) {
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) fn(list[i]);
  }
  function text(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function codes(v) { return String(v || '').toUpperCase().replace(/\s+/g, '').split(','); }

  /* ---------- the inline script of snippets/xv-delivery-timeline.liquid, for one box ---------- */
  var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY = 86400000;
  function fmt(ms) { var d = new Date(ms); return M[d.getUTCMonth()] + ' ' + d.getUTCDate(); }
  function rng(a, b) { var A = new Date(a), B = new Date(b); return A.getUTCMonth() === B.getUTCMonth() ? fmt(a) + '–' + B.getUTCDate() : fmt(a) + ' – ' + fmt(b); }
  function eta(box, lo, hi) {
    var z = box.getAttribute('data-tzo') || '+0000';
    var off = (z.charAt(0) === '-' ? -1 : 1) * (parseInt(z.substr(1, 2), 10) * 60 + parseInt(z.substr(3, 2), 10));
    if (isNaN(off)) return; /* the snippet skips such a box too: leave it exactly as rendered */
    var shop = new Date(Date.now() + off * 60000);
    var today = Date.UTC(shop.getUTCFullYear(), shop.getUTCMonth(), shop.getUTCDate());
    var n = 0, s1 = 0, s3 = 0;
    for (var i = 1; i <= 9 && !s3; i++) {
      var x = today + i * DAY, w = new Date(x).getUTCDay();
      if (w !== 0 && w !== 6) { n++; if (n === 1) s1 = x; if (n === 3) s3 = x; }
    }
    if (box.getAttribute('data-lo') !== String(lo)) box.setAttribute('data-lo', String(lo));
    if (box.getAttribute('data-hi') !== String(hi)) box.setAttribute('data-hi', String(hi));
    if (box.getAttribute(MARK) !== geo) box.setAttribute(MARK, geo);
    text(box.querySelector('[data-xv-eta="ship"]'), rng(s1, s3));
    text(box.querySelector('[data-xv-eta="arrive"]'), rng(s1 + lo * DAY, s3 + hi * DAY));
  }

  function apply() {
    if (!active) return;
    if (FREE.indexOf(geo) < 0) {
      each('.xv-sum .xv-sum__free', function (el) {
        el.classList.remove('xv-sum__free');
        text(el, 'At checkout');
        el.setAttribute(MARK, geo);
      });
    }
    var b = band(geo), s = band(STORE);
    each('[data-xv-eta-box]', function (box) {
      if (!box.hasAttribute(MARK)) {  /* as Liquid rendered it; ours are kept current */
        var lo = parseInt(box.getAttribute('data-lo'), 10), hi = parseInt(box.getAttribute('data-hi'), 10);
        if (lo === b[0] && hi === b[1]) return;  /* already this band */
        /* not the store country's band as listed above: the snippet's bands changed, so leave it */
        if (lo !== s[0] || hi !== s[1]) return;
      }
      eta(box, b[0], b[1]);
    });
    /* 3. 2-pack line: shown only when the detected country is on the line's own list; never hidden again */
    each('[data-xv-2pack][hidden]', function (el) {
      if (codes(el.getAttribute('data-countries')).indexOf(geo) < 0) return;
      el.hidden = false;
      el.setAttribute(MARK, geo);
    });
  }

  function watch() {
    document.addEventListener('cart-drawer:render', apply);
    document.addEventListener('cart-drawer:update', apply);
    document.addEventListener('cart-drawer:open', apply);
    window.addEventListener('pageshow', apply);
    window.addEventListener('load', apply);
    /* drawer or /cart markup swapped in by cart.js, product info re-rendered: run before paint.
       apply() itself only changes text and attributes, so it never triggers itself again. */
    if (window.MutationObserver && document.body) {
      new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          var a = recs[i].addedNodes;
          for (var j = 0; j < a.length; j++) {
            if (a[j].nodeType === 1) { apply(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function start(country) {
    var c = String(country || '').toUpperCase();
    if (active || !/^[A-Z]{2}$/.test(c) || c === STORE) return;
    geo = c;
    var b = band(c), s = band(STORE);
    if (FREE.indexOf(c) > -1 && b[0] === s[0] && b[1] === s[1]) return; /* nothing would change */
    active = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { apply(); watch(); });
    } else {
      apply();
      watch();
    }
  }

  window.xvShipGeo = {
    version: '2026-10-11-v5',
    free: FREE.slice(),
    bandB: BAND_B.slice(),
    bandC: BAND_C.slice(),
    apply: apply,
    country: function () { return active ? geo : ''; },
    isActive: function () { return active; }
  };

  if (!STORE || STORE !== DEFAULT) return;
  var gate = window.xvCardGate;
  if (gate && typeof gate.onSettle === 'function') {
    gate.onSettle(start);
  } else {
    /* the gate is missing or older: its cache only, never a request */
    var cached = '';
    try { cached = window.sessionStorage.getItem('xv_card_geo') || ''; } catch (e) { /* blocked */ }
    start(cached);
  }
})();
